import Bioheader from './Bioheader';
import Biofooter from './Biofooter';
import Biodatamain from './Biodatamain';
import { useEffect } from "react";
import "./Biodata.scss";
import { Helmet } from "react-helmet";

function Biodata() {
  useEffect(() => {
    document.body.classList.add("biodata_body");

    return () => {
      document.body.classList.remove("biodata_body"); 
    };
  }, []);
  return (
    <div className='container '>
      <Bioheader />
      <Helmet>
        <script type="application/ld+json">
          {`{
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is a marriage biodata maker?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A marriage biodata maker is a free online tool that helps you create a professional marriage biodata and download it in PDF or image format."
          }
        },
        {
          "@type": "Question",
          "name": "Is there any fee for creating a biodata?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No, this online marriage biodata maker is completely free to use with no hidden charges."
          }
        },
        {
          "@type": "Question",
          "name": "Do I need to create an account to make the biodata?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No account is required. You can directly enter your details and create your marriage biodata online without signing up."
          }
        },
        {
          "@type": "Question",
          "name": "How many types of templates are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Multiple professionally designed marriage biodata templates are available, allowing users to choose a layout as per their preference."
          }
        },
        {
          "@type": "Question",
          "name": "How do I download the biodata?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "After completing your biodata, simply click the download button to save it as a PDF or image file."
          }
        },
        {
          "@type": "Question",
          "name": "Can the biodata be downloaded in formats other than PDF?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, apart from PDF, you can also download your marriage biodata in image (PNG) format."
          }
        },
        {
          "@type": "Question",
          "name": "Is my information secure on your website?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, your information is secure and is not stored or shared with any third party."
          }
        },
        {
          "@type": "Question",
          "name": "Can the biodata have multiple pages?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, if the information is extensive, the biodata can automatically generate multiple pages."
          }
        }
      ]
    }
    `}
        </script>
        <script type="application/ld+json">
          {`{
          "@context": "https://schema.org",
          "@type": "NewsMediaOrganization",
          "@id": "https://gujarati.webdunia.com/#organization",
          "name": "Webdunia",
          "url": "https://gujarati.webdunia.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://nonprod-media.webdunia.com/public_html/app-logo/gu-logo.png",
            "width": 241,
            "height": 126
          },
          "sameAs": [
              "https://www.facebook.com/pages/Webdunia-Gujarati/200092490005294",
              "https://x.com/webdunia_Guj/",
              "https://www.youtube.com/channel/UCdxzHoHBXyY0Rsyuh4gZKUg",
              "https://www.instagram.com/webdunia.gujarati/"
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "60/2 Babulabh Chand Chajlani Marg Naidunia Parishar, Keshar Bagh Rd, Nai Duniya",
            "addressLocality": "Indore",
            "addressRegion": "Madhya Pradesh",
            "postalCode": "452009",
            "addressCountry": "IN"
          }
        }
    `}
        </script>
        <script type="application/ld+json">
          {`{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "@id":"https://gujarati.webdunia.com/biodata-maker#webpage",
          "name": "biodata maker",
          "description": "Create a professional Gujarati biodata online with our easy-to-use Gujarati Biodata Maker. Add personal details, education, family information, and more using customizable templates. Download your biodata in PDF or image format instantly. Perfect for marriage profiles and personal use, with support for Gujarati language formatting and modern designs.",
          "url": "https://gujarati.webdunia.com/biodata-maker",
          "inLanguage": "gu",
          "mainContentOfPage": "News",
          "publisher": {
          "@type": "NewsMediaOrganization",
          "@id":"https://gujarati.webdunia.com/#organization",
            "name": "Webdunia",
            "logo": {
              "@type": "ImageObject",
              "url": "https://nonprod-media.webdunia.com/public_html/include/_mod/site/common-images/wd-logo/logo-gu.png",
              "width": 180,
              "height": 94
            }
          }
        }
    `}
        </script>
        <script type="application/ld+json">
          {`{
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Biodata Maker",
        "description": "Create a professional Gujarati biodata online with our easy-to-use Gujarati Biodata Maker. Add personal details, education, family information, and more using customizable templates. Download your biodata in PDF or image format instantly. Perfect for marriage profiles and personal use, with support for Gujarati language formatting and modern designs.",
        "applicationCategory": "UtilityApplication",
        "operatingSystem": "Web",
        "url": "https://gujarati.webdunia.com/biodata-maker",
        "keywords": "Gujarati Biodata Maker, Free Gujarati Marriage Biodata Templates, Gujarati Bio Data Maker Online, Marriage Biodata Gujarati Format, Gujarati Matrimony Biodata PDF, Bio Data PDF Maker Gujarati, Gujarati Shaadi Biodata, Gujarati Resume for Marriage, Free Biodata Maker Gujarati, Easy Gujarati Biodata Generator, Gujarati Profile Maker for Marriage, લગ્ન બાયોડેટા, ગુજરાતી બાયોડેટા, લગ્ન સ્વપરિચય, બાયોડેટા ફોર્મેટ" ,
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "INR"
        }
      }
          `}
        </script>

      </Helmet>
      <Biodatamain />
      <Biofooter />
    </div>
  )
}

export default Biodata

